import type { ReactElement, ReactNode } from "react"
import { createContext, useEffect } from "react"
import { getBasket } from "~/store/basket/actions"
import { getBasketToken } from "~/store/basket/selectors"
import { useAppDispatch, useAppSelector } from "~/store/hooks"
import { getUserDataReady } from "~/store/selectors"

const CheckoutContext = createContext(false)

interface CheckoutContextProps {
  children: ReactNode
  skipBasketContext: boolean
}
export default function CheckoutContextWrapper({
  children,
  skipBasketContext,
}: CheckoutContextProps): ReactElement {
  const dispatch = useAppDispatch()
  const token = useAppSelector(getBasketToken)
  const isReady = useAppSelector(getUserDataReady)

  useEffect(() => {
    if (skipBasketContext) {
      return
    }
    dispatch(getBasket(token))
  }, [])

  return (
    <CheckoutContext.Provider value={isReady}>
      {children}
    </CheckoutContext.Provider>
  )
}
